// src/ShareLinkButton.tsx
import { useState } from "react";
import IconButton from "@mui/material/IconButton/index.js";
import Tooltip from "@mui/material/Tooltip/index.js";
import Snackbar from "@mui/material/Snackbar/index.js";
import Alert from "@mui/material/Alert/index.js";
import ShareIcon from "@mui/icons-material/esm/Share.js";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
var copyText = (text) => {
  if (navigator.clipboard && navigator.clipboard.writeText) {
    return navigator.clipboard.writeText(text);
  }
  return Promise.reject(new Error("Clipboard API unavailable"));
};
var ShareLinkButton = ({
  getUrl,
  tooltip = "Copy link",
  sx
}) => {
  const [open, setOpen] = useState(false);
  const handleClose = () => setOpen(false);
  const handleClick = (event) => {
    event.stopPropagation();
    const url = getUrl ? getUrl() : window.location.href;
    copyText(url).then(() => setOpen(true)).catch((err) => {
      console.error("Failed to copy URL: ", err);
      const textArea = document.createElement("textarea");
      textArea.value = url;
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand("copy");
      document.body.removeChild(textArea);
      setOpen(true);
    });
  };
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(Tooltip, { title: tooltip, arrow: true, children: /* @__PURE__ */ jsx(IconButton, { size: "small", onClick: handleClick, sx, children: /* @__PURE__ */ jsx(ShareIcon, { fontSize: "small" }) }) }),
    /* @__PURE__ */ jsx(
      Snackbar,
      {
        open,
        autoHideDuration: 2500,
        onClose: handleClose,
        anchorOrigin: { vertical: "top", horizontal: "center" },
        disableWindowBlurListener: true,
        children: /* @__PURE__ */ jsx(Alert, { onClose: handleClose, severity: "info", sx: { width: "100%" }, children: "Link copied to clipboard!" })
      }
    )
  ] });
};

export {
  ShareLinkButton
};
